(() => {
  const root = document.documentElement;
  const liveClass = 'kolekt-live-gradient-button';
  const kxClass = 'kolekt-live-gradient-button--kx';
  const clickableSelector = 'a, button, input[type="submit"], input[type="button"], [role="button"]';

  /* Every native primary button block now receives kolekt-gradient-action in
   * snippets/button.liquid. Keep this list explicit so cards, grade options,
   * tabs and secondary utility controls can never be animated by accident. */
  const primarySelector = [
    '.kolekt-gradient-action',
    '.kolekt-important-action',
    '.kolekt-track-primary',
    '.button-primary',
    '.button--custom-gradient',
    '.product-form__submit:not(:disabled)',
    'button[name="add"]:not(:disabled)',
    '.cart__checkout-button:not(:disabled)',
    '.hero a.button:not(.button-secondary, .button--secondary)',
    '#shopify-pc__banner #shopify-pc__banner__btn-accept',
    '#shopify-pc__prefs__dialog #shopify-pc__prefs__header-save'
  ].join(',');

  /* KolektX deliberately gives every content CTA its own orange/red motion. */
  const kxSelector = [
    '#MainContent [data-pf-type^="Button"]',
    '#MainContent .pf-button',
    '#MainContent .button',
    '#MainContent .button-primary',
    '#MainContent .button-secondary',
    '#MainContent .button--secondary',
    '#MainContent .kolekt-gradient-action',
    '#MainContent .kolekt-important-action',
    '#MainContent .kolekt-secondary-action',
    '.pagefly-container [data-pf-type^="Button"]',
    '.pagefly-container .pf-button',
    '.pagefly-container .button',
    '.pagefly-container .button-primary',
    '.pagefly-container .button-secondary',
    '.pagefly-container .button--secondary'
  ].join(',');

  const isKolektX = () => document.body?.classList.contains('kolektx-page');

  const visualElement = (candidate) => {
    if (!(candidate instanceof HTMLElement)) return null;
    if (candidate.matches(clickableSelector)) return candidate;
    return candidate.querySelector(clickableSelector) || candidate;
  };

  const mark = (candidate, kolektX = false) => {
    const element = visualElement(candidate);
    if (!element || element.closest('[data-kolekt-gradient="off"]')) return;

    if (!element.classList.contains(liveClass)) element.classList.add(liveClass);
    if (element.classList.contains(kxClass) !== kolektX) element.classList.toggle(kxClass, kolektX);
  };

  const cleanFalsePositives = (scope = document) => {
    scope.querySelectorAll(`.${liveClass}`).forEach((element) => {
      const belongsToKolektX = isKolektX() && (element.matches(kxSelector) || element.closest(kxSelector));
      if (!element.matches(primarySelector) && !belongsToKolektX) {
        element.classList.remove(liveClass, kxClass);
      }
    });
  };

  const collect = (scope = document) => {
    cleanFalsePositives(scope);
    scope.querySelectorAll(primarySelector).forEach((element) => {
      const belongsToKolektX = isKolektX() && (element.matches(kxSelector) || element.closest(kxSelector));
      mark(element, belongsToKolektX);
    });

    if (isKolektX()) {
      scope.querySelectorAll(kxSelector).forEach((element) => mark(element, true));
    }
  };

  let scheduled = false;
  const scheduleCollect = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      collect();
    });
  };

  const start = () => {
    if (!root.dataset.kolektGradientAnimation) root.dataset.kolektGradientAnimation = 'on';
    collect();

    new MutationObserver(scheduleCollect).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    new MutationObserver(scheduleCollect).observe(root, {
      attributes: true,
      attributeFilter: ['data-kolekt-gradient-animation']
    });

    document.addEventListener('shopify:section:load', scheduleCollect);
    document.addEventListener('shopify:block:select', scheduleCollect);
    document.addEventListener('PageFlyHelperContentLoaded', scheduleCollect);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
